

const $ = window.$;

$(document).ready(function () {

    // $('.sidebarAdminCollapse').on('click', function () {
    //     console.log("totoyo")
    //     $('#sidebar').toggleClass('active');
    // });

    if( isBreakpoint('xs') ) {
        console.log('xs');
    } 
});

function isBreakpoint( alias ) {

    return $('.device-' + alias).is(':visible');
}



// WEBPACK FOOTER //
// ./src/app/view/containers/Maintenance/js/Maintenance.js